module.exports = __webpack_public_path__ + "font/8e4a6dcc.eot";